module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en_US":{"export-as-html":"Export as HTML","export-as-pdf":"Export as PDF","save":"Save note","send-by-email":"Send by email"},"fr_FR":{"export-as-html":"Exporter en HTML","export-as-pdf":"Exporter en PDF","save":"Enregistrer la note","send-by-email":"Envoyer par email"}}')
  delete Component.options._Ctor
}
